import PropTypes from "prop-types";
import React from "react";
import WarningIcon from "@material-ui/icons/Warning";

export function Message(props) {
  const { message } = props.step.message;

  return (
    <div className="d-flex align-items-center justify-content-center">
      <WarningIcon />
      {message}
    </div>
  );
}

Message.propTypes = {
  step: PropTypes.shape({
    message: PropTypes.shape({
      message: PropTypes.any
    })
  })
};
